import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ConfirmModal from '../components/confirm-modal'

type Props = {
  visible: boolean
  closeModal: () => void
  listingId: string | null
}

const ListingExistsModal = ({ visible, closeModal, listingId }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()

  const goToListing = () => {
    closeModal()
    history.push(`/listing/edit/${listingId}`)
  }

  return (
    <ConfirmModal
      visible={visible}
      onClose={closeModal}
      title={t('l.listing.create.existing.title', 'Listing already exists')}
      subTitle={t(
        'l.listing.create.existing.descriTexttion',
        'It seems you have created this unit before.'
      )}
      onConfirm={goToListing}
      confirmText={t('r.listing.create.go_to_listing.button', 'Go to Listing')}
    />
  )
}

export default ListingExistsModal
